import { BaseCommand } from "@crunchdao/shared-cli";
import { StakingClient, formatCrunch, parseCrunch } from "@crunchdao/sdk";
import { Network } from "@crunchdao/sdk/staking-client";

export class DepositCommand extends BaseCommand {
  async execute(amount: number): Promise<void> {
    try {
      this.displayAction(`Depositing ${formatCrunch(parseCrunch(amount))} CRNCH`);

      const stakingClient = new StakingClient({
        connection: this.provider.connection,
        wallet: this.provider.wallet,
        network: this.network as Network,
      });

      const signature = await stakingClient.depositAmount(amount);

      this.displayActionComplete(`Deposited ${formatCrunch(parseCrunch(amount))} CRNCH`);
      console.log(`Transaction: ${signature}`);
    } catch (error) {
      console.error("❌ Error depositing tokens:", error);
      throw error;
    }
  }
}
